import { CustomerHandle } from "resource-planner-model";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { AppState } from "../redux/AppTypes";
import { createCustomersSelector } from "./useCustomers";

export const createSortedCustomersSelector = () =>
  createSelector(createCustomersSelector(), (customers) => {
    const sortedItems = customers.getAll().concat([]);
    sortedItems.sort((i1, i2) =>
      i1.name.toLowerCase().localeCompare(i2.name.toLowerCase())
    );
    return sortedItems;
  });

export function useSortedCustomers(
  year: number,
  month: number
): CustomerHandle[] {
  const selector = useMemo(createSortedCustomersSelector, []);
  return useSelector((state: AppState) => selector(state, year, month));
}
